// 定义懒加载插件（适配 Vue 2）
export const lazyPlugin = {
    install(app) {
        // 懒加载指令逻辑
        app.directive('img-lazy', {
            inserted(el, binding) {
                // 初始化懒加载
                initLazyLoad(el, binding.value);
            },
            update(el, binding) {
                // 如果图片地址发生变化，重新初始化懒加载
                const currentSrc = el.getAttribute('data-lazy-src') || el.src;
                if (currentSrc !== binding.value && binding.value) {
                    // 清除之前的 observer
                    if (el._lazyObserver) {
                        el._lazyObserver.unobserve(el);
                        el._lazyObserver = null;
                    }
                    // 重置图片状态
                    el.removeAttribute('data-lazy-loaded');
                    // 重新初始化懒加载
                    initLazyLoad(el, binding.value);
                }
            },
            unbind(el) {
                // 组件销毁时清理 observer
                if (el._lazyObserver) {
                    el._lazyObserver.unobserve(el);
                    el._lazyObserver = null;
                }
            }
        });
    }
}

function initLazyLoad(el, imgSrc) {
    if (!imgSrc) return;

    // 使用原生 IntersectionObserver API 判断是否进入视口区域
    if (!('IntersectionObserver' in window)) {
        // 不支持 IntersectionObserver 的浏览器，直接加载
        el.src = imgSrc;
        return;
    }

    // 保存图片地址到 data 属性
    el.setAttribute('data-lazy-src', imgSrc);
    
    // 如果已经加载过，不再重复加载
    if (el.hasAttribute('data-lazy-loaded')) {
        return;
    }

    // 设置一个透明的占位图，避免浏览器预加载
    if (!el.src || el.src === window.location.href) {
        el.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1 1"%3E%3C/svg%3E';
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // 进入了视口区域
                    const src = el.getAttribute('data-lazy-src');
                    if (src && el.src !== src) {
                        // 创建新图片对象预加载，确保加载完成后再替换
                        const img = new Image();
                        img.onload = () => {
                            el.src = src;
                            el.setAttribute('data-lazy-loaded', 'true');
                            el.removeAttribute('data-lazy-src');
                        };
                        img.onerror = () => {
                            el.removeAttribute('data-lazy-src');
                        };
                        img.src = src;
                    }
                    // 停止观察
                    observer.unobserve(el);
                    el._lazyObserver = null;
                }
            });
        },
        {
            // 可选配置：提前加载距离
            // 格式：'上 右 下 左' 或 '上下 左右' 或 '全部'
            // 例如：'200px' 表示所有方向提前 200px
            // '200px 0' 表示上下提前 200px，左右不提前
            rootMargin: '500px'
        }
    );

    // 保存 observer 引用
    el._lazyObserver = observer;
    
    // 开始观察元素
    observer.observe(el);
}

